import { useCallback, useEffect, useState } from "react";
import HeroHome from "../../components/HeroHome";
import ListMainServices from "../../components/ListMainServices";
import SectionListePrestataire from "../../components/SectionListePrestataires";
import "./Home.css";
import SectionListeDonneursOrdres from "../../components/SectionListeDonneursOrdres";
const Home = () => {
    const [prestataires, setPrestataires] = useState([]);
    const [donneursOrdres, setDonneursOrdres] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(false);
    const [totalPrestataires, setTotalPrestataires] = useState(0);
    const [totalDonneursOrdres, setTotalDonneursOrdres] = useState(0);
    const [showPresta, setShowPresta] = useState(true);
    const [metierFilter, setMetierFilter] = useState("");
    const [villeFilter, setVilleFilter] = useState("");

    const [page, setPage] = useState(1);
    const [pageDonneursOrdres, setPageDonneursOrdres] = useState(1);
    const limit = 8; // nb de prestataires par page

    const refreshDonneursOrdres = useCallback(() => {
        setLoading(true);
        const offset = (pageDonneursOrdres - 1) * limit;
        const params = new URLSearchParams({
            offset: offset.toString(),
            limit: limit.toString(),
        });
        const url = `${apiUrl}/api/search/donneursOrdres?${params.toString()}`;
        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                setDonneursOrdres(data.results);
                setTotalPrestataires(data.total);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [apiUrl, metierFilter, villeFilter, page]);
    const refreshPrestataires = useCallback(() => {
        setLoading(true);
        const offset = (page - 1) * limit;

        const params = new URLSearchParams({
            offset: offset.toString(),
            limit: limit.toString(),
        });
        if (metierFilter.length > 2) {
            params.append("metier", metierFilter);
        }
        if (villeFilter.length > 1) {
            params.append("ville", villeFilter);
        }

        const url = `${apiUrl}/api/search/prestataires?${params.toString()}`;
        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                setPrestataires(data.results);
                setTotalPrestataires(data.total);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [apiUrl, metierFilter, villeFilter, page]);

    useEffect(() => {
        refreshPrestataires();
        refreshDonneursOrdres();
    }, [refreshPrestataires, refreshDonneursOrdres]);

    const totalPagesPrestataire = Math.ceil(totalPrestataires / limit);
    const totalPagesDonneursOrdres = Math.ceil(totalDonneursOrdres / limit);


    return (
        <main>
            <HeroHome
                onMetierChange={setMetierFilter}
                onVilleChange={setVilleFilter}
                refresh={refreshPrestataires}
            />
            <ListMainServices />
            <button
                className="btn-primary"
                onClick={() => setShowPresta((prev) => !prev)}
            >
                {showPresta ? "Voir les donneurs d'ordres" : "Voir les prestataires"}
            </button>
            {
                showPresta && (
                    <SectionListePrestataire
                        total={totalPrestataires}
                        listPrestataires={prestataires}
                        title="Le réseau des professionnels certifiés et vérifiés"
                    />
                )
            }


            {/* Pagination */}
            {totalPagesPrestataire > 1 && showPresta && (
                <div className="pagination">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage((p) => p - 1)}
                    >
                        ⬅ Précédent
                    </button>
                    <span>
                        Page {page} / {totalPagesPrestataire}
                    </span>
                    <button
                        disabled={page === totalPagesPrestataire}
                        onClick={() => setPage((p) => p + 1)}
                    >
                        Suivant ➡
                    </button>
                </div>
            )}
            {
                !showPresta && (
                    <SectionListeDonneursOrdres
                        total={totalDonneursOrdres}
                        listDonneursOrdres={donneursOrdres}
                    />
                )
            }
            {/* Pagination donneurs d'ordres */}
            {totalPagesDonneursOrdres > 1 && !showPresta && (
                <div className="pagination">
                    <button
                        disabled={pageDonneursOrdres === 1}
                        onClick={() => setPageDonneursOrdres((p) => p - 1)}
                    >
                        ⬅ Précédent
                    </button>
                    <span>
                        Page {pageDonneursOrdres} / {totalPagesPrestataire}
                    </span>
                    <button
                        disabled={pageDonneursOrdres === totalPagesPrestataire}
                        onClick={() => setPageDonneursOrdres((p) => p + 1)}
                    >
                        Suivant ➡
                    </button>
                </div>
            )}
        </main>
    );
};

export default Home;
